import { useState, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUpperPopup } from '../../store/reducers/general'
import { getNextMembers } from '../../services/util'
import { videoService } from '../../services/video'
import { useNavigate } from 'react-router-dom'
import { VideoPopup } from './popup'

export function Researcher({ isAdmin, isEditable, part, status, videoId, isOpen }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { currentTeam, _id } = useSelector(state => state.user)
    const original = useRef(JSON.parse(JSON.stringify(part)))
    const [logistics, setLogistics] = useState(part.logistics)
    const [feedback, setFeedback] = useState(part.feedback)
    const [notes, setNotes] = useState(part.text)
    const [popup, setPopup] = useState('')
    const [changeFlag, setChangeFlag] = useState(false)
    const nextMembers = useRef(getNextMembers(currentTeam, _id, 'researcher'))
    const nextMember = useRef(null)
    const linkRefs = useRef({})

    const buttons = useMemo(() => {
        const buttons = []
        if (!isEditable) return null
        if (isEditable && changeFlag) {
            buttons.push(<div onClick={() => setPopup('discard-changes')} key='default' className='gray'>בטל שינויים</div>)
            buttons.push(<div onClick={() => setPopup('save-only')} key='save-only' className='save'>שמור שינויים</div>)
        }
        if (!isAdmin && isEditable) {
            buttons.push(<div onClick={() => setPopup('forward-as-success')} className='green' key='forward-as-success'>העבר כהצלחה</div>)
            buttons.push(<div onClick={() => setPopup('forward-as-failure')} className='red' key='forward-as-failure'>העבר ככשלון</div>)
        }
        if (isAdmin && status.level === 'researcher') {
            if (status.status.includes('forward')) buttons.push(<div onClick={() => setPopup('returned-for-changes')} key='reject' className='red' name='returned-for-changes'>החזר אחורה לתיקון</div>)
            const next = <div className='next-wrapper' key='select'>
                <select name='forward-to-selected' ref={nextMember} >
                    {nextMembers.current.map(member => <option value={member._id} key={member._id}>{member.name}</option>)}
                </select>
                <div onClick={() => setPopup('forward-to-selected')} className='green' name='forward-to-selected'>העבר</div>
            </div>
            buttons.push(next)
        }

        if (!buttons.length) return null
        return <div className='buttons-wrapper'>
            <p>{isAdmin ? 'אפשרויות' : 'הגש לבדיקה'}</p>
            <div className='buttons'>
                {buttons.map(button => button)}
            </div>
        </div>
    }, [isEditable, changeFlag, isAdmin])

    const handleButtonClick = async (ns) => {
        setPopup('')
        if (ns === 'discard-changes') {
            setLogistics(original.current.logistics)
            setNotes(original.current.text)
            setFeedback(original.current.feedback)
            setChangeFlag(false)
            return
        }
        dispatch(setUpperPopup('loader'))
        try {
            const minPrice = logistics.reduce((acc, logistic) => acc + Number(logistic.minPrice), 0)
            const maxPrice = logistics.reduce((acc, logistic) => acc + Number(logistic.maxPrice), 0)
            const e = { logistics, text: notes, feedback, minPrice, maxPrice }
            const nextSteps = ns === 'forward-to-selected' ? 'forward-to-' + nextMember.current.value : ns
            const { researcher } = await videoService.editVideo({ partToEdit: 'researcher', videoId, teamId: currentTeam._id, edit: e, nextSteps })
            original.current = researcher
            dispatch(setUpperPopup('video-edited'))
            setChangeFlag(false)
            if (nextSteps === 'save-only') {
                setLogistics(researcher.logistics)
                setNotes(researcher.text)
                setFeedback(researcher.feedback)
            }
            else navigate('/')
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const addLogistic = () => {
        setLogistics([...logistics, { item: '', links: [], notes: '', info: '', id: Date.now() }])
        setChangeFlag(true)
    }

    const editLogistic = (ev, idx, key) => {
        let l = [...logistics]
        l[idx][key] = ev.target.value
        setLogistics(l)
    }

    const deleteLogistic = (idx) => {
        setLogistics(logistics.filter((_, i) => i !== idx))
        setChangeFlag(true)
    }

    const addLink = (id) => {
        try {
            new URL(linkRefs.current[id].value)
        }
        catch {
            return dispatch(setUpperPopup('invalid-link'))
        }
        let i = structuredClone(logistics)
        i.find(item => item.id === id).links.push(linkRefs.current[id].value)
        setLogistics(i)
        linkRefs.current[id].value = ''
        setChangeFlag(true)
    }

    const deleteLink = (id, idx) => {
        let i = structuredClone(logistics)
        i.find(item => item.id === id).links.splice(idx, 1)
        setLogistics(i)
        setChangeFlag(true)
    }

    return <form id='researcher' onInput={(ev) => { if (ev.target.name !== 'forward-to-selected') setChangeFlag(true) }}>
        {isOpen && <div className='main3-back'>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <td>פריט</td>
                            <td>מידע</td>
                            <td>קישור</td>
                            <td>הערות</td>
                        </tr>
                    </thead>
                    <tbody>
                        {logistics.map((logistic, idx) => <tr key={logistic.id}>
                            <td>
                                <input placeholder='מה צריך?' type='text' value={logistic.item} onChange={(ev) => editLogistic(ev, idx, 'item')} readOnly={!isEditable} />
                                {isEditable && <div className="delete-absolute" onClick={() => deleteLogistic(idx)}><span className="material-symbols-outlined">delete</span></div>}
                            </td>
                            <td>
                                <textarea placeholder='מידע' type='text' value={logistic.info} onChange={(ev) => editLogistic(ev, idx, 'info')} readOnly={!isEditable} />
                            </td>
                            <td>
                                <div className='table-link'>
                                    {logistic.links?.map((link) => <div className="single-link" key={link}>
                                        {link && <span onClick={(ev) => { ev.stopPropagation(); navigator.clipboard.writeText(link); dispatch(setUpperPopup('copied')) }} className="material-symbols-outlined">content_copy</span>}
                                        {<span className="material-symbols-outlined" onClick={(ev) => { ev.stopPropagation(); deleteLink(logistic.id, link) }}>delete</span>}
                                        <a href={link} target='_blank'>{link.split('://')[1]?.slice(0, 8)}</a>
                                    </div>
                                    )}
                                    <div className="link-input-wrapper">
                                        <span className="material-symbols-outlined clickable add-link" onClick={() => addLink(logistic.id)}>add</span>
                                        <input
                                            placeholder='https://...'
                                            type='text'
                                            ref={el => {
                                                if (el) linkRefs.current[logistic.id] = el
                                            }}
                                        />
                                    </div>

                                </div>
                            </td>
                            <td>
                                <textarea placeholder='הערות' type='text' value={logistic.notes} onChange={(ev) => editLogistic(ev, idx, 'notes')} readOnly={!isEditable} />
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </div>

            {isEditable && <div className="add" onClick={addLogistic}>+ הוסף פריט</div>}

            {(status.status !== 'started' && status.level === 'researcher') && <>
                <h3>משוב - תחקירן</h3>
                <textarea className='area' readOnly={!isAdmin} value={feedback} placeholder="משוב מאדמין הצוות" onChange={(ev) => setFeedback(ev.target.value)} />
            </>}
            {popup && <VideoPopup close={() => setPopup('')} type={popup} onConfirm={handleButtonClick} />}
            {buttons}
        </div>}
    </form>
}